module.exports = __webpack_public_path__ + "img/161409924510923_image.jpg";